/* import __COLOCATED_TEMPLATE__ from './section.hbs'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['media-block__section'],
  attributeBindings: ['data-test-media-block-section'],
  'data-test-media-block-section': true
});